import { useLocation } from "react-router-dom";
import { Button } from "antd";
import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import { goToPaymentReturn } from "../../Utlis/PaymentReturn";
import logo from "../../Assets/Images/logo.svg";
import logoCompany from "../../Assets/Icons/companylogo.svg";
import "./style.css";

const STATUS_CONFIG = {
  success: {
    icon: <CheckCircleFilled />,
    title: "Payment Successful",
    badge: "PAID",
    description:
      "Your payment through WiPay has been completed successfully. The transaction will be reflected in your account shortly.",
  },
  failed: {
    icon: <CloseCircleFilled />,
    title: "Payment Failed",
    badge: "FAILED",
    description:
      "Your payment through WiPay could not be completed. No amount has been charged. Please try again.",
  },
};

const formatAmount = (total, currency) => {
  const num = parseFloat(total);
  if (Number.isNaN(num)) return total;
  return `${currency ? `${currency} ` : "$"}${num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
  })}`;
};

const PaymentStatusCard = ({ status }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.failed;

  const transactionId = params.get("transaction_id");
  const orderId = params.get("order_id");
  const total = params.get("total") || params.get("amount");
  const currency = params.get("currency");
  const reason = params.get("message") || params.get("reason");

  const details = [
    { label: "Transaction ID", value: transactionId },
    { label: "Order ID", value: orderId },
    { label: "Amount", value: total && formatAmount(total, currency) },
  ].filter((item) => item.value);

  const handleBack = () => {
    goToPaymentReturn();
  };

  return (
    <div className={`payment-status payment-status--${status}`}>
      <div className="payment-status__page">
        <div className="payment-status__logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="payment-status__card">
          <div className="payment-status__top-gradient"></div>

          <div className="payment-status__icon">{config.icon}</div>
          <div className="payment-status__heading">{config.title}</div>

          <div className="payment-status__badge-container">
            <span className="payment-status__badge">
              <span className="payment-status__dot"></span> {config.badge}
            </span>
          </div>

          <div className="payment-status__sub-heading">
            {config.description}
          </div>

          {status === "failed" && reason && (
            <div className="payment-status__reason">{reason}</div>
          )}

          {details.length > 0 && (
            <div className="payment-status__details">
              {details.map((item) => (
                <div className="payment-status__detail-row" key={item.label}>
                  <span className="payment-status__detail-label">
                    {item.label}
                  </span>
                  <span className="payment-status__detail-value">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          )}

          <Button
            type="primary"
            className="payment-status__button"
            onClick={handleBack}
          >
            <ArrowLeftOutlined />
            Back
          </Button>
        </div>

        <div className="payment-status__powered">
          <img src={logoCompany} alt="Logo Icon" />
          <div className="payment-status__powered-text">
            Powered by <span>CouSync</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusCard;
